import axios from "axios";
import store from "@/store";

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VER}`,
  headers: { "X-Requested-With": "XMLHttpRequest" },
  responseType: "json",
});

const ajaxBusyLoading = (axiosConfig, bool_start) => {
  const start = (typeof bool_start === 'boolean') ? bool_start : true;
  const params = axiosConfig.params;
  if (params && params.hasOwnProperty('polling') && params.polling) {
    // Do nothing, this URL should not affect ajax spinner.
  }
  else {
    store.dispatch('Busy/ajaxLoading', start);
  }
};

const convertJsonApiResourceIdsToIntegers = (data) => {
  if (typeof data === 'object' && data.data) {
    const transform = value => {
      let out = value;
      if (Array.isArray(value)) {
        value.forEach((innerValue, key) => {
          out[key] = transform(innerValue);
        });
      }
      else if (typeof value === 'object' && value) {
        Object.keys(value).forEach(key => {
          // Minimal JSON-API item contains { id: "string", type: "string" }
          if (key === 'id' && typeof value[key] === 'string' && value.hasOwnProperty('type')) {
            out[key] = parseInt(value[key], 10);
          }
          else {
            out[key] = transform(value[key]);
          }
        });
      }
      return out;
    };
    data = transform(data);
  }
  return data;
};

instance.interceptors.request.use(
  (config) => {
    // store.dispatch('Busy/ajaxLoading');
    ajaxBusyLoading(config);
    const token = store.state.auth.token;

    if (token) config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  },
  (error) => {
    // store.dispatch('Busy/ajaxLoading', false);
    ajaxBusyLoading(error.config, false);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // store.dispatch('Busy/ajaxLoading', false);
    ajaxBusyLoading(response.config, false);
    // Disabled until more testing has taken place
    if (false) {
      if (typeof response === 'object' && response.data && typeof response.data === 'object') {
        window.console && console.log('[RUNNING] convertJsonApiResourceIdsToIntegers');
        response.data = convertJsonApiResourceIdsToIntegers(response.data);
      }
    }
    else {
      window.console && console.log("[SKIPPED] convertJsonApiResourceIdsToIntegers");
    }
    return response;
  },
  (error) => {
    // store.dispatch('Busy/ajaxLoading', false);
    ajaxBusyLoading(error.config, false);
    switch (error.response.status) {
      case 422:
        let errors = error.response.data.errors;

        errors = Object.keys(errors).reduce((acc, key) => {
          let error = errors[key];

          if (!Array.isArray(error)) error = [error];

          return acc.concat(error);
        }, []);

        if (errors.length) {
          store.commit("snacktime", {
            text: errors.join("<br />"),
            color: "error",
          });
        }

        break;
      case 500:
        store.commit("snacktime", {
          text: error.response.data.message,
          color: "error",
        });

        break;
    }

    return Promise.reject(error);
  }
);

export default instance;
